import { render } from "./ProcessPickup.vue?vue&type=template&id=55a0533d&scoped=true"
import script from "./ProcessPickup.vue?vue&type=script&lang=js"
export * from "./ProcessPickup.vue?vue&type=script&lang=js"

import "./ProcessPickup.vue?vue&type=style&index=0&id=55a0533d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a0533d"]])

export default __exports__